export const STOP = "stop_recurrence";
export const STOP_AND_DELETE = "stop_and_delete_recurrence";
